import React, {useState} from 'react';
import {Button, Modal} from 'antd';
import {observer} from 'mobx-react';
import store from "./store";

import List from "./List"
import Form from "./Form"

import styles from '../layout.module.less'

// the hook
import { useTranslation } from 'react-i18next';

export default observer(function () {
  const { t } = useTranslation();
  const [visible, visibleUpdate] = useState(false)
  const [isAdd, isAddUpdate] = useState(false)
  const invoice = {
    title: ""
    , address: ""
    , tax_sn: ''
    , bank_name: ""
    , bank_number: ""
    , phone: ""
    , id: ''
    , is_default: false
    , is_del: false
  }

  return (
    <React.Fragment>
      <div className={styles.cart}>

        <div className={styles.listTitle}>
          <span className={styles.title}>{t('发票信息')}</span>
        </div>
        <div className="mainBox">
          <div className={styles.address}>
            <div className={styles.list}>
              <List setVisible={() => {
                visibleUpdate(true)
                isAddUpdate(false)
              }}/>
            </div>
          </div>

          <Modal
            title={isAdd ? '新增收货发票' : '编辑收货发票'}
            footer={false}
            centered
            getContainer={false}
            visible={visible}
            onOk={() => visibleUpdate(false)}
            onCancel={() => visibleUpdate(false)}
            width={768}
          >
            <Form setVisible={()=>{visibleUpdate(false)}}/>
          </Modal>


        </div>

      </div>
    </React.Fragment>
  )
})
